import { Video } from './videoPreview.styles';
import { VideoPreviewProps } from './videoPreview.types';

const VideoPreview = ({ media, className = '' }: VideoPreviewProps) => {
  return <Video data-test="video-preview" className={className} src={media} controls />;
};

export default VideoPreview;
